import { makeStyles } from 'tss-react/mui';

export default makeStyles()((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    minHeight: '70vh',
    width: '100%',
  },
  sectionContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  allSearchResultsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    width: '100%',
  },
  singleTabContainer: {
    width: '100%',
  },
  postSearchResultsListContainer: {
    width: '100%',
  },
  usersSearchResultsListContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  emptyResultsContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    padding: theme.spacing(4, 0),
    width: '100%',
  },
  tabRoot: {
    zIndex: 10,
    minWidth: '96px',
    fontWeight: 700,
  },
  tabIndicator: {
    position: 'absolute',
    height: '4px',
  },
  inputStyling: {
    fontSize: theme.typography.pxToRem(24),
    [theme.breakpoints.up(700)]: {
      fontSize: theme.typography.pxToRem(40),
    },
    fontWeight: 700,
    textTransform: 'uppercase',
  },
  searchIcon: {
    fontSize: theme.typography.pxToRem(24),
    [theme.breakpoints.up(700)]: {
      fontSize: theme.typography.pxToRem(40),
    },
  },
  clearIcon: {
    fontSize: theme.typography.pxToRem(24),
    [theme.breakpoints.up(700)]: {
      fontSize: theme.typography.pxToRem(40),
    },
    '&:hover': {
      cursor: 'pointer',
    },
  },
  submitButton: {
    display: 'none',
  },
}));
